module.exports = __webpack_public_path__ + "img/fy4.5a836f4e.png";